<template>
  <div id="app">
    <header>
      <h1>ECサイト</h1>
      <h2 v-if="userName">{{ userName }} さん、ようこそ!</h2>
      <router-link to="/cart">カートを見る</router-link> <!-- カートへのリンク -->
      <ShoppingCart :userName="userName" />
    </header>
    <main>
      <router-view />
    </main>
    <footer>
      <button @click="logout">ログアウト</button>
    </footer>
  </div>
</template>

<script>
import ShoppingCart from './components/ShoppingCart.vue';
import { computed } from 'vue';
import { useStore } from 'vuex'; // Vuexストアをインポート
import { useRouter } from 'vue-router'; // Vue Routerをインポート

export default {
  name: 'App',
  components: {
    ShoppingCart,
  },
  setup() {
    const store = useStore(); // ストアを使用
    const router = useRouter(); // routerを定義
    const userName = computed(() => store.getters.userName); // Vuexからユーザー名を取得

    const logout = () => {
      store.dispatch('logout'); // ログアウト処理を呼び出す
      router.push('/login'); // ログインページにリダイレクト
    };

    return {
      userName,
      logout,
    };
  },
};
</script>

<style>
#app {
  text-align: center;
}
header {
  background: #282c34;
  padding: 20px;
  color: white;
  position: relative;
}
main {
  flex: 1; /* 残りのスペースを占める */
  padding: 20px;
  overflow-y: auto; /* 縦方向にスクロール可能にする */
}
footer {
  padding: 10px;
  background: #f8f9fa;
  text-align: center;
}

footer button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

footer button:hover {
  background-color: #0056b3;
}
</style>